import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const DisclaimerPage = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />

      <div className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-extrabold text-gray-900 mb-6">Disclaimer</h1>
          <p className="text-gray-600 mb-12">Last Updated: January 2026</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section className="bg-red-50 border-2 border-red-300 rounded-2xl p-8">
              <div className="flex items-start space-x-4">
                <i className="ri-alert-line text-red-600 text-4xl flex-shrink-0"></i>
                <div>
                  <h2 className="text-3xl font-bold text-red-900 mb-4">Important Notice</h2>
                  <p className="text-gray-800 leading-relaxed text-lg">
                    <strong>InfoDrop.in is a fan-made information platform.</strong> We are NOT affiliated with, endorsed by, or connected to Garena, Free Fire, Krafton, BGMI, or any official game developers or publishers.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">General Information</h2>
              <p className="text-gray-700 leading-relaxed">
                The information provided on InfoDrop.in is for general informational and educational purposes only. While we strive to keep the information accurate and up-to-date, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information, products, services, or related graphics contained on the website.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">No Giveaway Organization</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                <strong>We do not organize, conduct, or sponsor any giveaways.</strong> InfoDrop.in is purely an information platform that provides:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Educational content about how giveaways work</li>
                <li>Safety guidelines for participating in community giveaways</li>
                <li>Information about gaming and technology topics</li>
              </ul>
              <p className="text-gray-700 leading-relaxed mt-4">
                Any giveaway entry forms on our website are for informational purposes only. We are not responsible for the distribution of any prizes or rewards.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">No Guarantees</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                InfoDrop.in makes no guarantees regarding:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Winning any giveaways or receiving any rewards</li>
                <li>The authenticity of third-party giveaway organizers</li>
                <li>The accuracy of giveaway information from external sources</li>
                <li>The availability or functionality of third-party services</li>
                <li>Any outcomes from following our guides or information</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Third-Party Giveaways</h2>
              <p className="text-gray-700 leading-relaxed">
                Any giveaways mentioned or referenced on our website are organized by independent third parties. We are not responsible for:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
                <li>The legitimacy of third-party giveaways</li>
                <li>Prize distribution or fulfillment</li>
                <li>Changes to giveaway terms or cancellations</li>
                <li>Disputes between participants and organizers</li>
                <li>Any losses or damages resulting from participation</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">User Responsibility</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                By using InfoDrop.in, you acknowledge that:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>You are responsible for verifying the authenticity of any giveaway before participating</li>
                <li>You participate in any giveaway at your own risk</li>
                <li>You should never share your account passwords with anyone</li>
                <li>You should exercise caution and common sense when sharing personal information</li>
                <li>You are responsible for your own online safety and security</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
              <p className="text-gray-700 leading-relaxed">
                All game names, trademarks, logos, and brands mentioned on InfoDrop.in are the property of their respective owners. We do not claim any ownership or affiliation with these brands. Any use of these names is for informational purposes only.
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
                <li><strong>Free Fire</strong> is a trademark of Garena International</li>
                <li><strong>BGMI (Battlegrounds Mobile India)</strong> is a trademark of Krafton Inc.</li>
                <li>All other trademarks belong to their respective owners</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed">
                In no event shall InfoDrop.in, its owners, employees, or affiliates be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mt-4">
                <li>Your use of or inability to use the website</li>
                <li>Any information obtained from the website</li>
                <li>Participation in any giveaways or promotions</li>
                <li>Unauthorized access to your personal information</li>
                <li>Any errors or omissions in the content</li>
              </ul>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">External Links</h2>
              <p className="text-gray-700 leading-relaxed">
                Our website may contain links to external websites. We have no control over the content, privacy policies, or practices of third-party sites and assume no responsibility for them. We encourage you to review the terms and privacy policies of any external sites you visit.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Changes to Content</h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify, update, or remove any content on our website at any time without prior notice. Information may become outdated, and we are not obligated to update it.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Professional Advice</h2>
              <p className="text-gray-700 leading-relaxed">
                The information on InfoDrop.in is not intended to be a substitute for professional advice. Always seek the advice of qualified professionals for specific situations.
              </p>
            </section>

            <section className="bg-yellow-50 border-2 border-yellow-300 rounded-2xl p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Safety Reminder</h2>
              <div className="space-y-4 text-gray-800">
                <p className="font-bold text-lg text-red-600">
                  <i className="ri-shield-cross-line mr-2"></i>
                  NEVER share your game account passwords with anyone!
                </p>
                <p className="leading-relaxed">
                  Legitimate giveaways will NEVER ask for your password. If someone asks for your password, it is a scam. Always verify the authenticity of giveaway organizers before participating.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Contact Information</h2>
              <p className="text-gray-700 leading-relaxed">
                If you have any questions about this Disclaimer, please contact us at:
              </p>
              <p className="text-blue-500 font-semibold mt-4">
                Email: contact@infodrop.in
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold text-gray-900 mb-4">Acceptance</h2>
              <p className="text-gray-700 leading-relaxed">
                By using InfoDrop.in, you acknowledge that you have read, understood, and agree to this Disclaimer. If you do not agree with any part of this Disclaimer, please do not use our website.
              </p>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default DisclaimerPage;
